import parse, { DOMNode, Element } from 'html-react-parser';
import Image from 'next/image';

const isElement = (domNode: DOMNode): domNode is Element => {
  return (
    domNode.type === 'tag' ||
    domNode.type === 'script' ||
    domNode.type === 'style'
  );
};

const parseHtml = (htmlToParse: string) => {
  return parse(htmlToParse, {
    // eslint-disable-next-line react/no-unstable-nested-components
    replace: (domNode) => {
      if (isElement(domNode)) {
        const { name, attribs, children } = domNode;
        if (name === 'img') {
          return (
            <Image
              alt={attribs.alt}
              src={attribs.src}
              width={2000}
              height={2000}
              className="w-full rounded-2xl"
            />
          );
        }

        return children;
      }
      return domNode;
    },
  });
};

export default parseHtml;
